<template>
  <v-container pa-0 style="width: 100%;">
    <div class="headline pt-4 pb-2"> Active Services </div>
    <ServiceItem v-for="service in activeServices" :key="service.id" :service="service" />
    <p v-if="activeServices.length == 0">There are no active services.</p>
    <div class="headline pt-4 pb-2"> Inactive Services </div>
    <ServiceItem v-for="service in inactiveServices" :key="service.id" :service="service" />
    <p v-if="inactiveServices.length == 0">There are no inactive services.</p>
  </v-container>
</template>

<script>
  import ServiceItem from '../ServiceItem'
  import {
    serviceMixin,
  } from '../../Helpers/Service'

  export default {
    components: {
      ServiceItem,
    },
    mixins: [serviceMixin],
    props: {
      services: Array,
    },
    computed: {
      activeServices() {
        return this.services.filter(s => this.isServiceActive(s))
      },
      inactiveServices() {
        return this.services.filter(s => !this.isServiceActive(s))
      },
    },
    mounted() {
      this.$emit('load', false)
    },
  }
</script>